import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { nanoid } from 'nanoid';
import { startLoadingTask, stopLoadingTask } from 'handlers/globalLoadingSlice';

interface IGlobalLoadingProps {
  taskId: string;
}

const STOP_LOADING_DELAY_MS = 500;

const GlobalLoading = ({
  taskId,
}: IGlobalLoadingProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const id = nanoid();

    dispatch(startLoadingTask({ taskId, id }));

    return () => {
      // Slight delay to ensure next components have time to mount and start their own loading tasks if needed
      setTimeout(() => {
        dispatch(stopLoadingTask({ taskId, id }));
      }, STOP_LOADING_DELAY_MS);
    };
  }, [taskId]);

  return null;
};

export default GlobalLoading;
